import { useEffect, useRef } from "react";

export function useFbPixelFire(cartSkuItems, cartTotal) {
  const prevCountRef = useRef(cartSkuItems?.length || 0);

  useEffect(() => {
    const isBeddoTestUser = localStorage.getItem("isBeddoTestUser") === "true";
    if (isBeddoTestUser) return;

    const currentCount = cartSkuItems?.length || 0;

    if (currentCount > prevCountRef.current) {
      window.fbq("track", "AddToCart", {
        value: cartTotal?.totalAmount,
        currency: "TRY",
      });

      window.ttq?.track("AddToCart", {
        contents:
          cartSkuItems?.map((item) => ({
            content_id: item.sku,
            content_type: "product",
            content_name: item.name,
          })) || [],
        value: cartTotal?.totalAmount,
        currency: "TRY",
      });

      // OPENAI ADS
      if (window.oaiq && typeof window.oaiq === "function") {
        window.oaiq("measure", "items_added", {
          type: "contents",
        });
      }
    }

    prevCountRef.current = currentCount;
  }, [cartSkuItems, cartTotal?.totalAmount]);
}
